import { Invoice } from "../../account/type/invoice";

export class InvoiceAdapter {
  static toOutputDTO(res: any): Invoice[] {
    return (
      res?.data?.map((e: any) => ({
        id: e.number,
        date: e.created,
        price: e.total,
        stripe: e.invoice_url,
      })) || []
    );
  }
}
